import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Form, Input, Radio } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { SupportFormNestedFieldsContainer } from "./nestedFieldsContainer.js";
import { useSupportFormProductType } from "../../hooks/useSupportFormProductType.js";
import { __, _i } from "../../utils/i18n.js";
const SupportFormWpPluginCompatibilityField = ()=>{
    const productTypes = useSupportFormProductType();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, curValues)=>prevValues.product !== curValues.product || prevValues.questionType !== curValues.questionType,
        children: (param)=>{
            let { getFieldValue } = param;
            const product = getFieldValue("product");
            const questionType = getFieldValue("questionType");
            if (!product || !questionType) {
                return null;
            }
            const { localized: localizedProduct } = productTypes[product];
            return questionType === ESupportTicketQuestionType.ProblemWithProduct && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Form.Item, {
                        label: __("Does the error persist if you disable %s in the installed plugins?", localizedProduct),
                        extra: __("You can always temporarily disable %s - this way no data and settings will be lost.", localizedProduct),
                        required: true,
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                name: "errorPersistsWithoutProduct",
                                rules: [
                                    {
                                        required: true,
                                        message: __("Please choose one option!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                            value: true,
                                            children: __("Yes")
                                        }),
                                        /*#__PURE__*/ _jsx(Radio.Button, {
                                            value: false,
                                            children: __("No")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                shouldUpdate: (prevValues, curValues)=>prevValues.errorPersistsWithoutProduct !== curValues.errorPersistsWithoutProduct,
                                children: (param)=>{
                                    let { getFieldValue } = param;
                                    return getFieldValue("errorPersistsWithoutProduct") ? /*#__PURE__*/ _jsx(Alert, {
                                        style: {
                                            margin: "15px 0"
                                        },
                                        message: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                _i(__("Disabled plugins cannot affect your website in WordPress. It is {{strong}}very unlikely{{/strong}} that %s is the reason for your issue.", localizedProduct), {
                                                    strong: /*#__PURE__*/ _jsx("strong", {})
                                                }),
                                                /*#__PURE__*/ _jsx("br", {}),
                                                /*#__PURE__*/ _jsx("br", {}),
                                                _i(__("{{strong}}How can you identify which plugin is causing the error?{{/strong}} Keep %s deactivated and now deactivate plugin by plugin and check from which plugin on everything works as usual again. Then contact the developers of this plugin.", localizedProduct), {
                                                    strong: /*#__PURE__*/ _jsx("strong", {})
                                                })
                                            ]
                                        }),
                                        type: "warning"
                                    }) : null;
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        shouldUpdate: (prevValues, curValues)=>prevValues.errorPersistsWithoutProduct !== curValues.errorPersistsWithoutProduct,
                        children: (param)=>{
                            let { getFieldValue } = param;
                            return getFieldValue("errorPersistsWithoutProduct") === false && /*#__PURE__*/ _jsxs(SupportFormNestedFieldsContainer, {
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        label: __("Please disable all plugins except %s. Does the problem still exist?", localizedProduct),
                                        extra: __("You can always temporarily disable your plugins - this way normally no data and settings will be lost."),
                                        required: true,
                                        name: "errorPersistsWithoutThirdPartyProduct",
                                        rules: [
                                            {
                                                required: true,
                                                message: __("Please choose one option!")
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Radio.Button, {
                                                    value: "yes",
                                                    children: __("Yes")
                                                }),
                                                /*#__PURE__*/ _jsx(Radio.Button, {
                                                    value: "no",
                                                    children: __("No")
                                                }),
                                                /*#__PURE__*/ _jsx(Radio.Button, {
                                                    value: "undefined",
                                                    children: __("I can't do")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Item, {
                                        noStyle: true,
                                        shouldUpdate: (prevValues, curValues)=>prevValues.errorPersistsWithoutThirdPartyProduct !== curValues.errorPersistsWithoutThirdPartyProduct,
                                        children: (param)=>{
                                            let { getFieldValue } = param;
                                            return getFieldValue("errorPersistsWithoutThirdPartyProduct") === "no" && /*#__PURE__*/ _jsxs(Form.Item, {
                                                label: __("Problematic plugin"),
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Alert, {
                                                        style: {
                                                            marginBottom: 15
                                                        },
                                                        message: __("Now activate plugin by plugin again. After each activation, please check if the error appears again. As soon as the error appears again, please note the plugin from which the error appears."),
                                                        type: "info"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Item, {
                                                        name: "faultyThirdPartyProduct",
                                                        noStyle: true,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: __("Please insert the problematic plugin!")
                                                            }
                                                        ],
                                                        children: /*#__PURE__*/ _jsx(Input, {})
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                ]
                            });
                        }
                    })
                ]
            });
        }
    });
};
export { SupportFormWpPluginCompatibilityField };
